import { CopyOutlined } from "@ant-design/icons";
import { Button, Col, Divider, InputNumber, Row, UploadFile, message } from "antd";
import FileUploads from "app/components/FileUploads";
import QuillEditor from "app/components/QuillEditor/QuillEditor";
import { useHandleSubmitApi } from "hook";
import { useState } from "react";
import { FileServices } from "services/file";
import { FormDataUtil } from "utils/form";
import "./InventoryImport.style.scss";

type P_Props = {};

const InventoryImportPresenter = (props: P_Props) => {
  // const { Panel } = Collapse;

  const [inventoryImages, setInventoryImages] = useState<UploadFile[]>([]);
  // const [imageBuildingOrientation, setImageBuildingOrientation] = useState<UploadFile | null>(null);
  const [imageBuildingOrientations, setImageBuildingOrientations] = useState<UploadFile[]>([]);
  const [content, setContent] = useState("");
  const [areaRange, setAreaRange] = useState<number[]>([]);

  const [dataCopied, setDataCopied] = useState({
    inventoryImages: [],
    imageBuildingOrientations: [],
    content: "",
    areaRange: [] as number[],
  });

  const [hadleUploadFiles, loadingUpload] = useHandleSubmitApi(async (data) => {
    const formData = FormDataUtil.convertJsonToFormData(data, {
      handelObjectInArr: (input) => {
        const temp = FormDataUtil.transformObjectFormData({
          mainKey: input.mainKey,
          data: input.data,
          mainIdx: input.mainIdx,
          customKeyForm: ({ mainKey, key, mainIdx }) => {
            return `${mainKey}[${mainIdx}][${key}]`;
          },
        });
        return temp;
      },
    });
    const dataRes = await FileServices.createFiles(formData);
    if (dataRes) {
      // insertToEditor(dataRes.data[0].url);
      return dataRes.data;
    }
  });

  const handleDataCopy = (value: any) => {
    console.log(85, value);
    navigator.clipboard
      .writeText(value)
      .then(() => {
        message.success("Successfully to copy content");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        message.error("Failed to copy text");
      });
  };

  return (
    <div className="inventory-import">
      <Row gutter={[20, 20]} style={{ maxWidth: "50rem", margin: "auto" }}>
        {/* <Col span={24}>
          <ExcelReader onChange={handleUpload} />
        </Col>

        <Col span={24}>
          <Button type="primary">
            <DownloadOutlined />
            Tải template
          </Button>
        </Col> */}

        <Col span={24}>
          <Divider orientation="left">Hình ảnh hàng tồn kho</Divider>
          <div className="w_100 mt_2">
            <FileUploads
              value={inventoryImages}
              onChange={(value) => {
                setInventoryImages(value as any);
              }}
              showUploadList={false}
              style={{ maxWidth: "10rem" }}
              // thumbnail={selectedThumbnail}
              // onChangeThumbnail={(value) => setSelectedThumbnail(value)}
            />

            <div className="d-flex items-center justify-flex-end">
              {inventoryImages.length ? (
                <Button
                  type="dashed"
                  loading={loadingUpload}
                  onClick={async () => {
                    const images = [];
                    for (const data of inventoryImages) {
                      if (data.originFileObj) {
                        images.push(data.originFileObj);
                      }
                    }
                    const dataImages = (await hadleUploadFiles({ files: images })) as any;
                    handleDataCopy(JSON.stringify(dataImages));
                    setDataCopied((prev) => ({ ...prev, inventoryImages: dataImages }));
                  }}
                >
                  <CopyOutlined />
                  <span>{!dataCopied["inventoryImages"].length ? "Copy to clipboard" : "Copied"}</span>
                </Button>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </Col>

        <Col span={24}>
          <Divider orientation="left">Ảnh layout kèm hướng toà nhà</Divider>
          <div className="w_100 mt_2">
            <FileUploads
              value={imageBuildingOrientations}
              onChange={(value) => {
                setImageBuildingOrientations(value as any);
              }}
              showUploadList={false}
              style={{ maxWidth: "10rem" }}
              // thumbnail={selectedThumbnail}
              // onChangeThumbnail={(value) => setSelectedThumbnail(value)}
            />

            <div className="d-flex items-center justify-flex-end">
              {imageBuildingOrientations.length ? (
                <Button
                  type="dashed"
                  loading={loadingUpload}
                  onClick={async () => {
                    const images = [];
                    for (const data of imageBuildingOrientations) {
                      if (data.originFileObj) {
                        images.push(data.originFileObj);
                      }
                    }
                    const dataImages = (await hadleUploadFiles({ files: images })) as any;
                    handleDataCopy(JSON.stringify(dataImages));
                    setDataCopied((prev) => ({ ...prev, imageBuildingOrientations: dataImages }));
                  }}
                >
                  <CopyOutlined />
                  <span>{!dataCopied["imageBuildingOrientations"].length ? "Copy to clipboard" : "Copied"}</span>
                </Button>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </Col>

        {/* <Col span={24}>
          <Divider orientation="left">Ảnh layout kèm hướng toà nhà</Divider>
          <div style={{ maxWidth: "50%" }}>
            <FileUpload
              value={imageBuildingOrientation}
              onChange={(value) => {
                setImageBuildingOrientation(value);
              }}
              showUploadList={false}
            />
          </div>

          <div className="d-flex items-center justify-flex-end">
            {!!imageBuildingOrientation ? (
              <Button
                type="dashed"
                loading={loadingUpload}
                onClick={async () => {
                  const dataImage = (await hadleUploadFiles({
                    files: imageBuildingOrientation["originFileObj"],
                  })) as any;
                  handleDataCopy(JSON.stringify(dataImage));
                  setDataCopied((prev) => ({ ...prev, imageBuildingOrientation: dataImage }));
                }}
              >
                <CopyOutlined />
                <span>{!dataCopied["imageBuildingOrientation"].length ? "Copy to clipboard" : "Copied"}</span>
              </Button>
            ) : (
              <span></span>
            )}
          </div>
        </Col> */}

        <Col span={24}>
          <Divider orientation="left">Các diện tích cho thuê</Divider>
          <div className="d-flex items-center justify-flex-end mb_1">
            {!!areaRange.length ? (
              <Button
                type="dashed"
                onClick={() => {
                  handleDataCopy(JSON.stringify(areaRange));
                  setDataCopied((prev) => ({ ...prev, areaRange: areaRange }));
                }}
              >
                <CopyOutlined />
                <span>{!dataCopied["areaRange"].length ? "Copy to clipboard" : "Copied"}</span>
              </Button>
            ) : (
              <span></span>
            )}
          </div>

          {areaRange.map((d, idx) => {
            return (
              <div className="mb_1 d-flex items-center justify-space-between" key={idx}>
                <InputNumber
                  value={d}
                  className="w_90"
                  onChange={(number) => {
                    const clone = [...areaRange];
                    clone[idx] = number || 0;
                    setAreaRange(clone);
                  }}
                  size="large"
                />

                {areaRange?.length > 1 && (
                  <Button
                    type="primary"
                    shape="circle"
                    icon={"-"}
                    danger
                    onClick={() => {
                      const clone = [...areaRange];
                      clone.splice(idx, 1);
                      setAreaRange(clone);
                    }}
                  />
                )}
              </div>
            );
          })}
          <Button
            type="dashed"
            // shape="circle"
            icon={"+ Thêm mới"}
            size="large"
            onClick={() => {
              setAreaRange([...areaRange, 0]);
            }}
            style={{ width: "30%" }}
          />
        </Col>

        <Col span={24}>
          <Divider orientation="left">Nội dung thông tin</Divider>
          <div className="d-flex items-center justify-flex-end">
            {!!content ? (
              <Button
                type="dashed"
                onClick={() => {
                  handleDataCopy(JSON.stringify(content));
                  setDataCopied((prev) => ({ ...prev, content }));
                }}
              >
                <CopyOutlined />
                <span>{!dataCopied["content"].length ? "Copy to clipboard" : "Copied"}</span>
              </Button>
            ) : (
              <span></span>
            )}
          </div>
          <div className="w_100 mt_2">
            <QuillEditor
              content={content}
              onChange={(value) => {
                setContent(value);
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InventoryImportPresenter;
